import React from "react";
import PropTypes from "prop-types";
import * as views from "./constants/views";
import ConnectedTeamModalContent from "./ConnectedTeamModalContent";
import { ModalStateProvider } from "./ModalStateContext";

const TeamModal = ({
    displayTeamCreateInitially = false,
    enableTeamJoin = false,
}) => {
    const initialView =
        enableTeamJoin && !displayTeamCreateInitially
            ? views.JOIN_TEAM
            : views.CREATE_TEAM;

    return (
        <ModalStateProvider initialView={initialView}>
            <ConnectedTeamModalContent />
        </ModalStateProvider>
    );
};

TeamModal.propTypes = {
    displayTeamCreateInitially: PropTypes.bool,
    enableTeamJoin: PropTypes.bool,
};

export default TeamModal;
